import React, { useState } from "react";
import { CONSTANTS } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context/GlobalContext";
import { requestOTPHandler, signInHandler } from "../../utils/authHelpers";
import { errorHandler, localStorageHandler } from "../../utils/helpers";
import { useToastContext } from "../../context/ToastContext";
import AuthScreen from "../../components/AuthScreen";

const SignIn = () => {
  const [email, setEmail] = useState<string>("");
  const [otp, setOTP] = useState<string>("");
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [showOTPScreen, setShowOTPScreen] = useState<boolean>(false);
  const [authError, setAuthError] = useState<string>("");


  const { setUser, isLoading, setIsLoading } = useGlobalContext();
  const { showToast } = useToastContext();
  const navigate = useNavigate();

  const emailChangeHandler = (e: Event) => {
    let target = e.target as HTMLInputElement;
    setEmail(target.value);

    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    if (target.value && emailRegex.test(target.value)) {
      setAuthError("");
      setIsDisable(false);
    } else {
      target.value === ""
        ? setAuthError("")
        : setAuthError(CONSTANTS.APP_ERRORS.INVALID_EMAIL_ERROR);
      setIsDisable(true);
    }
  };

  const otpRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsDisable(true);
    setIsLoading(true);
    const otpRes = await requestOTPHandler(email, "Login");
    if (!otpRes?.error) {
      if (otpRes.data.success) {
        showToast(otpRes.data.message, "success");
        setShowOTPScreen(true);
        setAuthError("");
      } else {
        setShowOTPScreen(false);
        setAuthError(otpRes.data.message);
      }
    } else {

      let error = await errorHandler(otpRes);
      setAuthError(error);
      setShowOTPScreen(false);
      showToast(error, "error");
    }
    setIsDisable(false);
    setIsLoading(false);
  };

  const verifyOTPAndLogin = async () => {
    try {
      setIsLoading(true);
      let res = await signInHandler(otp, "Login");

      if (res?.data?.success) {
        const userData = res.data.data;
        showToast(res?.data?.message, "success");

        localStorageHandler(
          "set",
          CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT,
          userData.token
        );
        localStorageHandler(
          "set",
          CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT,
          userData
        );

        setUser(userData);
        navigate("/dashboard");
        setIsLoading(false);
      } else if (res?.error) {
        let error = errorHandler(res);
        setAuthError(error);
      } else {
        setAuthError(res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const otpChangeHandler = (otp: string) => {
    setOTP(otp);
  };

  return (
    <>
      <AuthScreen
        showOTPScreen={showOTPScreen}
        email={email}
        authError={authError}
        isDisable={isDisable}
        isLoading={isLoading}
        changeHandler={emailChangeHandler}
        otpRequest={otpRequest}
        otpChangeHandler={otpChangeHandler}
        verifyOTPAndLogin={verifyOTPAndLogin}
        isLoginScreen={true}
      />
    </>
  );
};

export default SignIn;
